import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingAnimation } from './Utilities';
import UserSkillResource from '../resource/UserSkillResource';
import { skillShapeBasic, userShape } from '../propTypes';

function NothingFound({ availableSkills, availableLoading, nothingFoundClick }) {
  if (!availableSkills.length && !availableLoading) {
    return (
      <div>
        Nothing found
        <button className="ml-2 btn btn-secondary btn-sm" type="button" onClick={nothingFoundClick}>Clear</button>
      </div>
    );
  }
  return null;
}

function SkillAllAvailable({
  user,
  loadSkills,
  doLoadAvailableList,
  availableSkills,
  setAvailableSkills,
  availableLoading,
  setAvailableLoading,
  availableSkillsAfterLoad,
  setAvailableSkillsAfterLoad,
  filterValue,
  setFilterValue,
}) {
  let loadListTimeoutId;

  const filterAvailableSkills = (event) => {
    console.log(2);
    clearTimeout(loadListTimeoutId);
    setFilterValue(event.target.value);
    if (event.target.value.length) {
      setAvailableSkills(
        availableSkillsAfterLoad.filter(
          (filterSkill) => filterSkill.title.indexOf(event.target.value) !== -1,
        ),
      );
    } else if (availableSkillsAfterLoad.length) {
      setAvailableSkills(availableSkillsAfterLoad);
    } else {
      loadListTimeoutId = setTimeout(doLoadAvailableList, 500);
    }
  };

  const endorse = async (skill) => {
    setAvailableLoading(true);
    await UserSkillResource.post(user.id, skill.id);
    await loadSkills();
    setAvailableSkillsAfterLoad(
      availableSkillsAfterLoad.filter((filterSkill) => filterSkill.id !== skill.id),
    );
    setAvailableSkills(availableSkills.filter((filterSkill) => filterSkill.id !== skill.id));
    setAvailableLoading(false);
  };

  const keyUpFilter = (event) => {
    if (event.key === 'Backspace') {
      return filterAvailableSkills(event);
    }
    return null;
  };

  const nothingFoundClick = () => {
    setFilterValue('');
    doLoadAvailableList();
  };

  useEffect(() => { doLoadAvailableList(); }, []);

  return (
    <div className="results">
      <LoadingAnimation loading={availableLoading} />
      <div className="mb-2">
        <input autoComplete="off" onChange={filterAvailableSkills} onKeyUp={keyUpFilter} className="form-control" type="search" placeholder="Filter Skills" value={filterValue} disabled={availableLoading} />
      </div>

      <NothingFound
        availableSkills={availableSkills}
        availableLoading={availableLoading}
        nothingFoundClick={nothingFoundClick}
      />

      {availableSkills.map((skill) => (

        <button
          type="button"
          key={skill.id}
          className={`endorsement skill-${skill.type} m-1`}
          onClick={() => endorse(skill)}
          title={`Endorse ${user.name} for ${skill.title}`}
          style={{
            outline: 'none', borderBottom: 'none', borderTop: 'none', borderRight: 0,
          }}
        >
          {skill.title}
          <span
            className="skill-add-button"
          >
            +
          </span>
        </button>

      ))}

    </div>
  );
}

SkillAllAvailable.propTypes = {
  user: userShape.isRequired,
  loadSkills: PropTypes.func.isRequired,
  doLoadAvailableList: PropTypes.func.isRequired,
  availableSkills: PropTypes.arrayOf(skillShapeBasic).isRequired,
  setAvailableSkills: PropTypes.func.isRequired,
  availableLoading: PropTypes.bool.isRequired,
  setAvailableLoading: PropTypes.func.isRequired,
  availableSkillsAfterLoad: PropTypes.arrayOf(skillShapeBasic).isRequired,
  setAvailableSkillsAfterLoad: PropTypes.func.isRequired,
  filterValue: PropTypes.string.isRequired,
  setFilterValue: PropTypes.func.isRequired,
};

export default SkillAllAvailable;
